<template>
  <div>
    <div>
      <div>
        <div class="w-full">
          <h3 class="text-4f4f4f text-xl font-semibold mb-0">
            Product Attributes
          </h3>
          <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
            Mix and match attributes and create different variations of this
            product with pricing.<br />
            The first attribute selected will be the primary attribute.
          </p>
        </div>
      </div>

      <div class="mt-12">
        <div class="flex justify-between">
          <div>
            <h3 class="text-4f4f4f text-xl mb-0 font-semibold">
              {{
                productDetail.attributesId
                  ? productDetail.attributesId[0].name
                  : "Attribute Name"
              }}
            </h3>
            <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
              Add photos to showcase your offerings
            </p>
          </div>
          <div>
            <p
              @click="openPop()"
              class="fill-chips rounded-lg fsize12 bg-primary text-white px-8 cursor-pointer py-2"
            >
              Add
            </p>
          </div>
        </div>
        <!-- <div>
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">
              Add Attribute Value
            </p>
            <el-input
              placeholder="Enter or Type Attributes value..."
              v-model="attributeVal"
              @change="addAttributeValuePrimary"
              class="rounded-xl mt-2"
            />
          </div>

          <div class="mt-6">
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Image</p>
            <el-upload
              v-if="datavalue.length == 0"
              class="upload-demo mt-1 category-uploader"
              multiple
              drag
              :before-upload="multipleimages"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              
            </el-upload>
            <div class="mt-6 grid grid-cols-4 gap-2">
              <div
                v-for="(item, index) in renderedmultipleImage"
                class="relative"
                :key="item"
              >
                <img
                  :src="item"
                  class="rounded-4px object-cover w-full imgpre h-75px"
                />

                <div
                  class="absolute top-0 xiconset right-0 bg-white rounded-full p-1"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer flex"
                    @click="
                      () => {
                        datavalue.splice(index, 1);
                        renderedmultipleImage.splice(index, 1);
                      }
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6 flex justify-center">
            <vs-button
              @click="saveAttributeVal()"
              type="primary"
              class="rounded-full fsize14 bg-primary text-white px-16 font-semibold cursor-pointer py-4"
            >
              Save
            </vs-button>
          </div>
        </div> -->
        <div class="mt-8">
          <div
            v-for="(color, index) in onClickProduct.productImageId"
            :key="`${color}+${index}`"
          >
            <div class="flex justify-between">
              <h3 class="text-4f4f4f text-lg mb-0">{{ color.valueName }}</h3>
              <!-- <feather-icon
                icon="Trash2Icon"
                svgClasses="w-6 h-6"
                class="text-8f8f8f"
              /> -->
            </div>

            <div class="grid grid-cols-5 gap-6 mt-4">
              <div
                class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
                v-for="(colorIMG, index) in color.productImage"
                :key="`${colorIMG}+${index}`"
              >
                <img
                  :src="imageURL + colorIMG"
                  class="rounded-4px object-cover w-full imgpre h-75px"
                />
              </div>
            </div>
          </div>
          <!-- <div class="mt-8">
          <div class="flex justify-between">
            <h3 class="text-4f4f4f text-lg mb-0">Pink</h3>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 h-6"
              class="text-8f8f8f"
            />
          </div>

          <div class="grid grid-cols-5 gap-6 mt-4">
            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
              <input type="file" class="choosefilecs" />
            </div>

            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
              <input type="file" class="choosefilecs" />
            </div>

            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
              <input type="file" class="choosefilecs" />
            </div>

            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
              <input type="file" class="choosefilecs" />
            </div>

            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-10 h-10" />
              <input type="file" class="choosefilecs" />
            </div>
          </div>
        </div> -->
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-8">
        <vs-button
          type="primary"
          class="bg-primary rounded-lg font-semibold py-5 fsize14"
          @click="closePopup"
          >Save</vs-button
        >

        <vs-button
          type="secondary"
          class="bg-secondary rounded-lg font-semibold py-5 fsize14"
          @click="closePopup"
          >Cancel</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import addAttributeVal from "./addAttributeVal";
export default {
  props: {
    productDetail: {
      type: Object,
    },
  },
  components: {
    addAttributeVal,
  },
  data() {
    return {
      activeNames: "1",
      AddColor: false,
      value1: [],
      value2: [],
      Attribute2: [],
      primaryAttribute: null,
      secondaryAttribute: null,
      // productDetail: {},
      attribute1: "",
      attribute2: "",
      attributeVal: [],
      datavalue: [],
      renderedmultipleImage: [],
      attributessizeOptions: [
        {
          value: "XL",
          label: "XL",
        },
        {
          value: "LG",
          label: "LG",
        },
      ],
    };
  },
  methods: {
    async openPop() {
      this.AddColor = true;
      this.$emit("closePopup");
      let payload1 = {
        attributeName: this.primaryAttribute,
      };
      await this.$store.dispatch(
        "EcomAttributes/getSingleAttributesPrim",
        payload1
      );
    },
    async addAttributeValuePrimary() {
      let payload = {
        attributeValue: this.attributeVal,
        attributeName: this.singleAttrinutesPrime.name,
      };
      console.log(singleAttrinutesPrime);
      console.log(payload);
      await this.$store.dispatch("EcomAttributes/addAttributesValue", payload);
    },
    async multipleimages(file) {
      // console.log(file.target.files,"khk");
      console.log(file);
      console.log(this.datavalue);
      if (this.datavalue.length < 5) {
        this.datavalue.push(file);
      } else {
        this.datavalue.shift(file);
      }
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 5) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },
    async saveAttributeVal() {
      const payload = new FormData();
      payload.append("valueName", this.attributeVal);
      payload.append("productId", this.onClickProduct._id);
      for (let i in this.datavalue) {
        payload.append("productImage", this.datavalue[i]);
      }

      await this.$store.dispatch("EcomProduct/productImage", payload);
      await this.$store.dispatch("EcomProduct/getAllProduct");
    },
    closePopup() {
      this.$emit("closePopupMain");
    },
    async addAttributePrm() {
      let payload = {
        name: this.primaryAttribute,
        // productId: this.$store.state.EcomAttributes.onClickProduct._id,
        productId: this.onClickProduct._id,
      };
      await this.$store.dispatch("EcomAttributes/addAttributes", payload);
    },
    async addAttributeSec() {
      let payload = {
        name: this.secondaryAttribute,
        // productId: this.$store.state.EcomAttributes.onClickProduct._id,
        productId: this.onClickProduct._id,
      };
      await this.$store.dispatch("EcomAttributes/addAttributes", payload);
    },
  },
  computed: {
    ...mapState("EcomAttributes", [
      "EcomAttrinutes",
      "singleAttrinutesPrime",
      "singleAttrinutesSec",
      "onClickProduct",
    ]),
    imageURL() {
      // return "https://nimbuscluster.blob.core.windows.net/server01/";
      return `${this.$imageUrl ? this.$imageUrl : this.$imageURL}/`;
    },
  },
  mounted() {
    console.log(this.productDetail);
  },
};
</script>
